import { callApi } from './api';

import { ApiResult } from '@/types/api';
import { Child } from '@/types/child';

type Guardian = {
  id: number;
  relation_ship: 'father' | 'mother' | 'grandfather' | 'grandmother' | 'uncle' | 'aunt' | 'other';
};

type Doctor = {
  number?: number;
  clinic_name?: string;
  phone_number?: string;
  doctor_name?: string;
};

type OtherFacility = {
  number?: number;
  name?: string;
  city?: string;
};

type RecipientCertificate = {
  image?: string;
  start_date: string;
  end_date: string;
  is_locked: boolean;
  is_deleted: boolean;
};

export type UpdateChildRequest = {
  contract_start_date: string;
  contract_end_date?: string;
  last_name: string;
  first_name: string;
  last_name_kana: string;
  first_name_kana: string;
  birth_date: string;
  guardians: Guardian[];
  email: string;
  phone_number: string;
  postal_code: string;
  prefecture: string;
  city: string;
  address1: string;
  address2?: string;
  emergency_contact_relation: string;
  emergency_contact_phone: string;
  office_ids: number[];
  school_id: number;
  school_phone_number?: string;
  school_grade: string;
  doctors: Doctor[];
  has_upper_management: boolean;
  other_facilities: OtherFacility[];
  seal_registration_image?: string;
  recipient_certificates: RecipientCertificate[];
  recipient_certificate_number: number;
  support_type: string;
  support_days: string;
  max_monthly_burden_amount: number;
  recipient_certificate_notes?: string;
  recipient_certificate_guardian_name?: string;
  recipient_certificate_guardian_birth_date?: string;
  rehabilitation_certificate_image?: string;
  assessment_sheet_image?: string;
  disability_details?: string;
  allergies?: string;
  training_location?: string;
  notes?: string;
};

export const updateChild = async (
  childID: number,
  input: UpdateChildRequest
): Promise<ApiResult<Child>> => {
  const { status, result } = await callApi<Child>(
    `children/${childID}`,
    'PUT',
    undefined,
    input,
    undefined,
    undefined,
    true
  );
  return { status, result };
};
